import { formatPrice } from 'utils';
import type { ItemType } from 'components/InlineSearch/ItemInlineSearch';
import type { AppFragment, MenuVariantFragment, PosProductFragment, ProductFragment } from 'types/graphqlFragment';

export const getMaxMinPrice = (
  menuItem: ProductFragment | MenuVariantFragment,
  apps?: AppFragment[]
): Array<string> => {
  const { variablesByApp } = menuItem;

  let min = 0;
  let max = 0;

  variablesByApp.forEach(({ price, app }) => {
    if (!apps || apps.find(({ id }) => id === app.id)) {
      const _price = price as number;

      if (!min || _price < min) {
        min = _price;
      }

      if (!max || _price > max) {
        max = _price;
      }
    }
  });

  return [formatPrice(min), formatPrice(max)];
};

export const productResultToInlineSearchItem = (
  item: ProductFragment | PosProductFragment,
  posPrice?: number,
  enabled = true
): ItemType => {
  let priceString = '';
  if (item.__typename === 'Product') {
    const [min, max] = getMaxMinPrice(
      item,
      item.variablesByApp.map((v) => v.app)
    );
    if (min === max) priceString = min;
    else priceString = `${min}-${max}`;
    if (posPrice) priceString = formatPrice(posPrice);
  } else if (item.__typename === 'POSProduct') priceString = formatPrice(item.unitPrice);

  return {
    item: {
      name: item.name,
      description: item.posId,
      price: priceString,
      key: item.__typename === 'Product' ? item.mmId : item.posId,
      imageUri:
        (item.__typename === 'Product' ? item.variablesByApp.find((vba) => vba.imageUri)?.imageUri : item.imageUri) ||
        '/Images/NoImage.svg'
    },
    enabled
  };
};
